module.exports = __webpack_public_path__ + "img/header-weddingRingsFancy.19b8006.jpg";